import { clsx } from "clsx";
import {
  Activity,
  BarChart3,
  Bookmark,
  Briefcase,
  Compass,
  GanttChart,
  LayoutDashboard,
  Library,
  ScrollText,
  Settings as SettingsIcon,
  ShieldAlert,
  Sunrise,
} from "lucide-react";
import { NavLink } from "react-router-dom";
import { APP_VERSION } from "@/lib/version";

const NAV = [
  { path: "/", label: "Dashboard", icon: LayoutDashboard },
  { path: "/manager", label: "Manager", icon: Compass },
  { path: "/briefing", label: "Briefing", icon: Sunrise },
  { path: "/screener", label: "Screener", icon: BarChart3 },
  { path: "/portfolio", label: "Portfolio", icon: Briefcase },
  { path: "/watchlist", label: "Watchlist", icon: Bookmark },
  { path: "/strategies", label: "Strategies", icon: Library },
  { path: "/policy", label: "Policy", icon: GanttChart },
  { path: "/governance", label: "Governance", icon: ShieldAlert },
  { path: "/audit", label: "Audit", icon: ScrollText },
  { path: "/settings", label: "Settings", icon: SettingsIcon },
];

export function Sidebar() {
  return (
    <aside className="hidden w-56 flex-col border-r border-border bg-surface-raised md:flex">
      <div className="flex items-center gap-2 px-4 py-4">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent/15 text-accent-strong">
          <Activity size={16} />
        </span>
        <div>
          <p className="text-sm font-semibold">Equity Research</p>
          <p className="text-2xs uppercase tracking-wider text-foreground-muted">
            v{APP_VERSION}
          </p>
        </div>
      </div>
      <nav className="flex-1 space-y-0.5 px-2 py-2">
        {NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                clsx(
                  "flex items-center gap-2 rounded-md px-2.5 py-1.5 text-sm transition",
                  isActive
                    ? "bg-accent-subtle text-accent-strong"
                    : "text-foreground-secondary hover:bg-surface-subtle hover:text-foreground-primary",
                )
              }
            >
              <Icon size={16} />
              {item.label}
            </NavLink>
          );
        })}
      </nav>
      <footer className="border-t border-border-subtle px-4 py-3 text-2xs text-foreground-muted">
        Decision support, not advice.
      </footer>
    </aside>
  );
}
